import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {Session} from '../../../interfaces/session-data';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable, throwError} from 'rxjs';
import {Actions, ofActionDispatched, Select, Store} from '@ngxs/store';
import {catchError, filter} from 'rxjs/operators';
import {MapState, MapStateModel, PaymentKeyState} from '../../shared/map.state';
import {HttpErrorResponse} from '@angular/common/http';
import { AdumoeftService } from 'src/app/services/adumoeft/adumoeft.service';
import { AdumoeftPaymentResponse } from 'src/app/interfaces/adumoeft/Adumoeft';
import { SetPaymentStepAdumoeft } from '../../shared/map.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-adumoeft',
  templateUrl: './adumoeft.component.html',
  styleUrls: ['./adumoeft.component.scss']
})
export class AdumoeftComponent implements OnInit {

  paymentMethod: string;
  paymentMethodImg = '';
  redirectUrl;
  controllerUrl;
  loading = true;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  //Countdown
  config = { leftTime: 5, format: 's' };
  hidePgLogo = false;
  sessionData: Session;

  constructor(
    private adumoeftService: AdumoeftService,
    private router: Router
  ) {
    sessionStorage.setItem('selected-payment', 'eft_adumo');
    this.paymentMethod = 'eft_adumo';
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;

  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    this.adumoeftService.initializePayment(sessionStorage.getItem('sessionToken')).subscribe((data: AdumoeftPaymentResponse) => {
      this.redirectUrl = data.paymentUrl;
      window.location.href=this.redirectUrl;
    }, (err: HttpErrorResponse) => {
      this.navigateToStatus();
    });
  }

  navigateToStatus() {
    this.loading = false;
    this.router.navigate(
      [`transaction-status`]);
  }

}
